import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_association_contract_view",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "association_contract_view",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_association_contract_view_button",
  "data-kt-drawer-close": "#kt_drawer_association_contract_view_close",
  "data-kt-drawer-width": "50.5vw"
}
const _hoisted_2 = {
  id: "kt_association_contract_view",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_association_contract_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Entity Contract Info </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_association_contract_view_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_association_contract_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_association_contract_body",
  "data-kt-scroll-dependencies": "#kt_association_contract_header, #kt_association_contract_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = ["model", "rules"]
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "mb-5 mb-xl-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-6 px-8" }, " Association Info ", -1)
const _hoisted_10 = { class: "card-body p-9" }
const _hoisted_11 = { class: "row mb-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Tranche", -1)
const _hoisted_13 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_14 = { class: "fw-bold fs-6 me-2" }
const _hoisted_15 = { class: "row mb-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Association", -1)
const _hoisted_17 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_18 = { class: "fw-bold fs-6 me-2" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Contract Number", -1)
const _hoisted_21 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_22 = { class: "fw-bold fs-6 me-2" }
const _hoisted_23 = { class: "row mb-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Contract Name", -1)
const _hoisted_25 = { class: "col-lg-8" }
const _hoisted_26 = { class: "fw-bold fs-6 me-2" }
const _hoisted_27 = { class: "row mb-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, " Sign Date ", -1)
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_31 = { class: "row mb-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Start", -1)
const _hoisted_33 = { class: "col-lg-8" }
const _hoisted_34 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_35 = { class: "row mb-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "End", -1)
const _hoisted_37 = { class: "col-lg-8" }
const _hoisted_38 = { class: "fw-bold fs-6" }
const _hoisted_39 = { class: "row mb-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Training Target", -1)
const _hoisted_41 = { class: "col-lg-8" }
const _hoisted_42 = { class: "fw-bold fs-6" }
const _hoisted_43 = { class: "row mb-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Contract Amount", -1)
const _hoisted_45 = { class: "col-lg-8" }
const _hoisted_46 = { class: "fw-bold fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "position-relative row",
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef"
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.formData?.tranche?.label), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.formData?.entity?.entity_name) + " (" + _toDisplayString(_ctx.formData?.entity?.entity_short_name) + ") ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formData.contract_number), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formData.contract_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formData.sign_date), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.formData.start), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formData.end), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.formData.target), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.formData.amount), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ], 8, _hoisted_5)
      ])
    ])
  ]))
}